import React, { forwardRef } from "react";

/**
 * @typedef Props
 * @property {'lg' | 'xl'} size 
 * @property {boolean} line
 * @property {string} label
 */

/**
 * @param {Props} props
 */
function Spacer(props, ref) {
    return <div
            ref={ref}
            className={"spacer"
                + (props.label || props.line ? "-line" : "")
                + (props.size ? "-" + props.size : "")
                + (props.vertical ? " vertical" : "")
                + (props.className ? " " + props.className : "")
            }
        >
        {props.label ? <h3>{props.label}</h3> : null}
    </div>
}

export default forwardRef(Spacer)